
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MenuItem } from '@/store/menu/menu';
import { languageModule } from '@/store/languages';

@Options({
  name: 'SidebarMenu'
})
export default class SidebarMenu extends Vue {
  @Prop({ type: Object, required: true })
  readonly menuItems!: MenuItem[];

  get items() {
    const lang = languageModule.locale === 'ru' ? 'ru' : 'en';
    return this.menuItems.map((menuItem) => {
      return {
        ...menuItem,
        serverPath: menuItem.serverPath?.replace('{{language}}', lang) ?? menuItem.serverPath
      };
    });
  }
}
